// extracted by mini-css-extract-plugin
module.exports = {"preview":"styles_preview__34Vzq","container":"styles_container__3EsLk","minimized":"styles_minimized__SS8Yb"};